export const ClockedUnitStatus = {
    PendingApproval: 0,
    ReadyForProcessing: 1,
    Processed: 2,
    NoClocks: 3,
    SentToDavid: 4,
    Disapproved: 5
};
